import React, { Component } from 'react';
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Fab, Select, Tooltip, withStyles} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import firebase from '../../firebase'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';

const filter = createFilterOptions();

const styles = theme => ({
    paper: {
        padding: 16,
        margin: theme.spacing(2),
        // height: '100%',
        overflowY: 'auto'
    },
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    absolute: {
        margin: 0,
        top: 'auto',
        right: 20,
        bottom: 20,
        left: 'auto',
        position: 'fixed',
        // position: 'absolute',
        // bottom: theme.spacing(2),
        // right: theme.spacing(3),
    },
})

class CreateItem extends Component{

    constructor(props) {
        super(props)

        this.state = {
            editMode: false,
            id: "",
            open: false,
            name: "",
            category: "",
            amount: "",
            imageUrl: "",
            message: "",
            visible: "10",
            error: false,
            value: null,
            type: 10
        }

        this.database = firebase.database().ref().child('food').child('food-items')
    }

    componentDidMount() {
        const {editMode, item } = this.props
        if (editMode === true) {
            console.log(editMode)
            const { id, name, category, amount, imageUrl, message, type } = item
            this.setState({
                editMode: editMode,
                id: id,
                name: name,
                category: category,
                value: category,
                amount: amount,
                imageUrl: imageUrl,
                message: message ? message : "",
                type: type
            })
        }
    }

    handleClickOpen = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleSubmit = () => {
        //TODO:- Validate the form!
        const { editMode, id, name, category, amount, imageUrl, message, type } = this.state
        
        if (editMode) {
            this.updateItemData(id, name, category, amount, imageUrl, message, type)
        } else {
            this.writeUserData(name, category, amount, imageUrl, message, type)
        }
        
    }

    updateItemData = (id, name, category, amount, imageUrl, message, type) => {
        this.database.child(id).update({
            name: name,
            category: category,
            amount: amount,
            imageUrl: imageUrl,
            message: message,
            type: String(type)
        })

        this.setState({
            open: false,
        })
    }

    writeUserData = (name, category, amount, imageUrl, message, type) => {
        this.database.push({
            name: name,
            category: category, 
            amount: amount,
            imageUrl: imageUrl, 
            message: message, 
            type: String(type),
            visible: true
        })

        this.setState({
            open: false,
            name: "",
            category: "",
            amount: "",
            imageUrl: "",
            message: "",
            type: "10",
            error: false, 
            value: null
        })
    }


    handleChange = name => event => {
        this.setState({
            [name] : event.target.value
        })
    }

    render() {
        const { open, name, category, amount, imageUrl, message, type, error, value } = this.state
        const { categories, editMode, classes } = this.props
        return (
            <div>
                {
                    editMode ? 
                        <Button size="small" color="primary" onClick={this.handleClickOpen}>
                            Edit
                        </Button>
                        :
                        // <Button color="inherit" onClick={this.handleClickOpen}>New Item</Button>
                        // <Fab size="small" aria-label="add" onClick={this.handleClickOpen}>
                        //     <AddIcon />
                        // </Fab>
                        <Tooltip title="Add">
                            <Fab color="secondary" className={classes.absolute} onClick={this.handleClickOpen}>
                                <AddIcon />
                            </Fab>
                        </Tooltip>

                }
                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle id="form-dialog-title">{editMode ? "Edit Item 🍰" : "Create a New Item 🍩"}</DialogTitle>
                    <DialogContent>
                        <form>
                            <TextField
                                autoFocus
                                error={error && name === ""}
                                margin="normal"
                                id="name"
                                label="Item Name"
                                type="text"
                                value={name}
                                onChange={this.handleChange('name')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                required
                                variant="outlined"
                            />
                            <Autocomplete
                                id="combo-box-demo"
                                value={value}
                                color="secondary"
                                style={{ marginTop: 12 }}
                                onChange={(event, newValue) => {
                                    if (newValue && newValue.inputValue) {
                                        this.setState({
                                            value: newValue.inputValue,
                                            category: newValue.inputValue,
                                        });

                                        return;
                                    }

                                    if (newValue && newValue.title) {
                                        this.setState({
                                            value: newValue,
                                            category: newValue.title,
                                        });

                                        return;
                                    }
                                }}
                                filterOptions={(options, params) => {
                                    const filtered = filter(options, params);

                                    if (params.inputValue !== '') {
                                        filtered.push({
                                            inputValue: params.inputValue,
                                            title: `Add "${params.inputValue}"`,
                                        });
                                    }

                                    return filtered;
                                }}
                                options={categories}
                                getOptionLabel={(option) => {
                                    // e.g value selected with enter, right from the input
                                    if (typeof option === 'string') {
                                        return option;
                                    }
                                    if (option.inputValue) {
                                        return option.inputValue;
                                    }
                                    return option.title;
                                }}
                                renderOption={(option) => option.title}
                                fullWidth
                                renderInput={params => (
                                    <TextField
                                        {...params}
                                        color="secondary"
                                        label="Category"
                                        variant="outlined"
                                        value={category}
                                        fullWidth
                                        onChange={this.handleChange('category')}
                                    />
                                )}
                            />
                            {/* <TextField
                                margin="normal"
                                id="category"
                                label="Category"
                                type="text"
                                value={category}
                                onChange={this.handleChange('category')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                variant="outlined"
                            /> */}
                            <TextField
                                margin="normal"
                                id="amount"
                                label="Amount"
                                type="number"
                                value={amount}
                                onChange={this.handleChange('amount')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                variant="outlined"
                            />
                            <TextField
                                margin="normal"
                                id="message"
                                label="Special Message"
                                type="text"
                                value={message}
                                onChange={this.handleChange('message')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                variant="outlined"
                            />
                            <Select
                                native
                                label="Type"
                                value={type}
                                onChange={this.handleChange('type')}
                                inputProps={{
                                    name: 'Type',
                                    id: 'age-native-simple',
                                }}
                                fullWidth
                                color="secondary"
                                style={{ marginTop: 18 }}
                                variant="outlined"
                            >
                                <option value={10}>Veg</option>
                                <option value={20}>Egg</option>
                                <option value={30}>Non-Veg</option>
                            </Select>
                            <TextField
                                margin="normal"
                                id="imageUrl"
                                label="Image URL"
                                type="text"
                                value={imageUrl}
                                onChange={this.handleChange('imageUrl')}
                                fullWidth
                                color="secondary"
                                autoComplete="off"
                                variant="outlined"
                            />
                        </form>
                    </DialogContent>
                    <DialogActions style={{ marginRight: 16, marginBottom: 8,}}>
                        <Button onClick={this.handleClose} color="primary">
                            Cancel
                        </Button>
                        <Button type="submit" variant="contained" onClick={this.handleSubmit} color="primary">
                            {editMode ? "Update" : "Add"}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

export default withStyles(styles)(CreateItem)